import moment from 'moment';
import 'moment-duration-format';
import commaNumber from 'comma-number';

export function convertTimeCreditToTimeFormat(mills) {
  return moment.duration(mills).format('h[시간] m[분] s[초]');
}

export function formatUtcDateToLocalDateFormat(utc) {
  return moment
    .utc(utc)
    .local()
    .format('YYYY-MM-DD');
}

export function formatLocalDateToYYYYMMDD(local) {
  return moment(local).format('YYYY-MM-DD');
}

export function formatDateToYYYYMMDDhhmmss(utc) {
  return moment
    .utc(utc)
    .local()
    .format('YYYY-MM-DD HH:mm:ss');
}

export function calculateDayDiff(moment1, moment2) {
  return moment2
    .local()
    .startOf('day')
    .diff(moment1.local().startOf('day'), 'days');
}

export function calculateTimeDiff(moment1, moment2) {
  return convertTimeCreditToTimeFormat(moment(moment2).diff(moment(moment1)));
}

export const convertTimeCreditToPcBangPoint = (timeCredit, decimalPoint = 0) => {
  const convertedPoint = (timeCredit / TIME_CREDIT_OVER_PC_BANG_POINT).toFixed(decimalPoint);
  return `${commaNumber(convertedPoint)} pt`;
};

export const convertPcBangPointToTimeCredit = (point, decimalPoint = 0) => {
  return (point.toFixed(3) * TIME_CREDIT_OVER_PC_BANG_POINT).toFixed(decimalPoint);
};

export const compareDateTime = (dateString1, dateString2) => {
  return moment.utc(dateString1).isAfter(moment.utc(dateString2)) ? -1 : 1;
};
